import { yupResolver } from '@hookform/resolvers/yup';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../hooks/store';
import { errorMessage } from '../../hooks/useNotifications';
import { createPropThunk, propExistThunk } from '../../redux/reducer/propSlice';
import { withErrorHandler } from '../../utils/utils';
import {
  CreateUserData,
  createUserSchema,
  EmailValidationData,
  emailValidationSchema
} from '../../validation/login';
import Button from '../button/Button';
import Input from '../input/Input';

const SignUp: React.FC<{ from: string }> = ({ from }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isLoading = useAppSelector(state => state.prop.isLoading);
  const [isNewProp, setIsNewProp] = useState<boolean | undefined>(undefined);

  const {
    register,
    handleSubmit,
    getValues,
    resetField,
    formState: { errors }
  } = useForm<CreateUserData | EmailValidationData>({
    resolver: yupResolver(isNewProp ? emailValidationSchema : createUserSchema)
  });

  const onSubmit = async (data: CreateUserData | EmailValidationData) => {
    await withErrorHandler(async () => {
      if (!isNewProp) {
        const { exist } = await dispatch(propExistThunk({ email: data.email })).unwrap();
        setIsNewProp(!exist);
        if (exist) {
          errorMessage('Email already exists! Please login.');
        }
      } else {
        await dispatch(createPropThunk(data as EmailValidationData)).unwrap();
        navigate(from, { replace: true });
      }
    });
  };
  const commonProps = {
    register,
    errors,
    required: true,
    className: `bg-gray-200  rounded-md  font-medium text-black`
  };
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col mt-3">
        <Input type="email" placeholder="Enter Your Email" name="email" hidden={isNewProp} {...commonProps} />
        {isNewProp && (
          <div className="space-y-2 mb-4">
            <p className="font-medium">
              <span>{getValues('email')}</span>{' '}
              <button
                className="text-[#35e0a1] underline"
                onClick={() => {
                  setIsNewProp(undefined);
                  resetField('email');
                  resetField('password');
                  resetField('confirmPassword');
                }}
                type="button"
              >
                Change
              </button>
            </p>
          </div>
        )}

        <Input
          type="password"
          placeholder="Enter Your Password"
          name="password"
          hidden={isNewProp}
          {...commonProps}
        />
        <Input
          type="password"
          placeholder="Confirm Your Password"
          hidden={isNewProp}
          name="confirmPassword"
          {...commonProps}
        />
        {!isNewProp && (
          <div className="mt-2">
            <p className="font-medium">- Must include 8 characters</p>
            <p className="font-medium">- Must include a number</p>
            <p className="font-medium">- Must include a special character</p>
          </div>
        )}

        <Input type="text" placeholder="Enter Otp" hidden={!isNewProp} name="otp" {...commonProps} />

        <Button
          type="submit"
          className="bg-[#35e0a1] mt-2 h-[35px] rounded-md font-medium"
          label="Sign Up"
          isLoading={
            isLoading[propExistThunk.pending.toString()] || isLoading[createPropThunk.pending.toString()]
          }
        />
      </form>
    </div>
  );
};

export default SignUp;
